import gql from 'graphql-tag'

export const User = gql`
  fragment User on User {
    email
    id
    fullName
    personalProfiles {
      id
      title
      name
      designation
      appraisalAssigns {
        id
        status
        startDate
        endDate
        insertedAt
        appraisal {
          id
          name
          type
        }
      }
      school {
        id
      }
      media {
        url
      }
      user {
        userRoles {
          name
        }
      }
    }
  }
`

export const PERSONAL_PROFILE = gql`
  fragment PersonalProfile on PersonalProfile {
    id
    name
    designation
    roles {
      role {
        name
        permissions
      }
    }
    media {
      id
      url
      fileName
    }
  }
`
